// React, Next
import { useTranslation } from 'next-i18next'

// MUI
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

// Custom
import Section from '@/components/sections/Section'
import SectionHeader from '@/components/sections/SectionHeader'
import BulletGrid from '@/components/sections/BulletGrid'

// Style
import themeColors from 'assets/theme/colors'
import { getFontBody } from '@/assets/theme/fonts'

export default function WhyItMattersSection() {
  const { t } = useTranslation('technology')

  const items = [
    t('why.items.01'),
    t('why.items.02'),
    t('why.items.03'),
    t('why.items.04')
  ]

  const getContent = () => (
    <Box sx={{ width: '100%' }}>
      <SectionHeader
        eyebrow={t('why.eyebrow')}
        title={t('why.title')}
        intro={[t('why.intro1'), t('why.intro2')]}
      />

      <BulletGrid items={items} columns={1} />

      <Box sx={{ marginTop: '2rem', maxWidth: '52rem' }}>
        {[t('why.outro1'), t('why.outro2')].map(paragraph => (
          <Typography
            key={paragraph}
            component="p"
            fontSize={getFontBody()}
            sx={{
              lineHeight: 1.7,
              color: themeColors.gray.defaultText,
              marginBottom: '1rem',
              '&:last-of-type': { marginBottom: 0 }
            }}
          >
            {paragraph}
          </Typography>
        ))}
      </Box>
    </Box>
  )

  // *** MAIN RENDER ***
  return (
    <Section
      background={themeColors.section.light}
      paddingTop="5rem"
      paddingBottom="5rem"
      content={getContent()}
    />
  )
}
